import { Component, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AppComponent {
  navigation = new Subject();
  currentNavigation: string;

  goTo() {
    this.navigation.next(this.currentNavigation);
    return this.navigation;
  }
}
